import React, { useEffect, useState, useRef } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";
// import FileUploadComponentForHB from "../../../../Components/formElements/FileUploadComponentForHB";
import Spinner from "react-bootstrap/Spinner";

//API
import ItemService from "../../../../services/supplier_appCommonService";
import SupplierConstants from "../../../../common/SupplierConstants";
import DataTable from "react-data-table-component";
import { currencyFormat } from "../../../../common/Validations";
import toast from "react-hot-toast";

import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import { useDispatch } from "react-redux";
import { getInvoiceList } from "../../../../redux/feature/supplier_app/purchasingSlice";

const POInvoiceUploadModal = React.forwardRef((props, ref) => {
  console.log(">>Props", props?.viewInvoiceData);
  // Show an input field only when it has an available (non-empty, non-zero) value
  const hasValue = (val) =>
    val !== null &&
    val !== undefined &&
    val !== "" &&
    val !== "0" &&
    val !== "0.00" &&
    !(Number(val) === 0);
  // A line item is worth showing only if it carries actual invoice data (item
  // code, HSN, qty, rate or amount). Fully-empty OCR rows (e.g. a blank second
  // line) are hidden from the table.
  const hasLineItemValues = (row) =>
    [
      row?.itemCode,
      row?.hsnSac,
      row?.quantity,
      row?.rate,
      row?.taxableValue,
      row?.total,
    ].some((v) => v !== null && v !== undefined && v !== "");
  const fileInputRef = useRef(null);
  // Generation token so a cancelled OCR upload ignores its in-flight response
  const uploadTokenRef = useRef(0);
  const [file, setFile] = useState(null);
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);

  const dispatch = useDispatch();

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  const modalData = {
    title: "Invoice Creation",
    successMsg: "",
  };

  const [parentInfo, setParentInfo] = useState();
  const [uploadStatus, setUploadStatus] = useState(false);
  const [viewInvoiceDataStatus, setViewInvoiceDataStatus] = useState(false);
  const [getInvoiceLineItem, setInvoiceLineItem] = useState([]);
  console.log(">>getInvoiceLineItem", getInvoiceLineItem);

  // Line-item edit popup state
  const [editingItem, setEditingItem] = useState(null);
  const [showItemModal, setShowItemModal] = useState(false);

  const [getHeaderData, setHeaderData] = useState(false);
  const [disabled, setDisabled] = useState(false);
  console.log(">>getHeaderData", getHeaderData);

  // const [data, setData] = useState([]);
  const [totalOrderQuantity, setTotalOrderQuantity] = useState(0);

  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getModalInfo, setModalInfo] = useState(modalData);
  const [wasModalShown, setWasModalShown] = useState(false);
  const [ocrInvoiceData, setOcrInvoiceData] = useState({});
  console.log(">>ocrInvoiceData", ocrInvoiceData);

  const [invoiceData, setInvoiceData] = useState({
    vendorInvoiceNo: "",
    vendorInvoiceDate: "",
    vendorBasicValue: "",
    vendorTotalInvoiceValue: "",
    dispInvoiceStatusHeader: "",
    dispCreatedBy: "",
    dispCreatedByName: "",
    deliveryName: "",
    dispTotalQty: "",
    dispBasicPricePerUnit: "",
    dispBasicPrice: "",
    dispCGST: "",
    dispSGST: "",
    dispTransporterCode: "",
    dispTransporterName: "",
    dispVehieleRegNo: "",
    dispCustomerCode: "",
    igst: "",
    supplierGSTIN: "",
    supplierPAN: "",
    supplierPhone: "",
    taxAmountInWords: "",
    items: [],
    dispCompanyBankDetails: [],
    invoiceBillDocument: "",
    purchasingDocumentNr: "",
    purchasingDocumentDate: "",
    purchasingDocumentValue: "",
    currencyCode: "",
    currency: "",
    vendorCode: "",
    vendorName: "",
    paymentTerms: "",
    incoTerms: "",
    companyCodeCode: "",
    purchaseType: "",
    invoiceType: "",
  });

  // Only show a data column when at least one line item carries a value for it.
  // (react-data-table-column's omit is per-row, so we conditionally include the
  // whole column in the array instead. Sl.No and Action always render.)

  const itemCode = {
    name: "Item Code",
    selector: (row) => row.itemCode,
    sortable: true,
    width: "200px",
    cell: (row) => (
      <div>
        <p className="m-0 p-0 pt-1 fw-bold">{row.itemCode} </p>
      </div>
    ),
  };
  const description = {
    name: "Description",
    selector: (row) => row.description,
    sortable: true,
    width: "220px",
    cell: (row) => (
      <div>
        <p className="m-0 p-0 pt-1 fw-bold">{row.description} </p>
      </div>
    ),
  };
  const hsnSac = {
    name: "HSN/SAC",
    selector: (row) => row.hsnSac,
    sortable: true,
    width: "120px",
    cell: (row) => (
      <div>
        <p className="m-0 p-0 pt-1 fw-bold">{row.hsnSac} </p>
      </div>
    ),
  };
  const unit = {
    name: "Unit",
    selector: (row) => row.unit,
    sortable: true,
    width: "100px",
    cell: (row) => (
      <div>
        <p className="m-0 p-0 pt-1 fw-bold">{row.unit} </p>
      </div>
    ),
  };
  const quantity = {
    name: "Qty",
    selector: (row) => row.quantity,
    sortable: true,
    width: "100px",
    cell: (row) => (
      <div>
        <p className="m-0 p-0 pt-1 fw-bold">{row.quantity} </p>
      </div>
    ),
  };

  const rate = {
    name: "Rate",
    selector: (row) => row.rate,
    sortable: true,
    width: "100px",
    cell: (row) => (
      <div>
        <p className="m-0 p-0 pt-1 fw-bold">{row.rate} </p>
      </div>
    ),
  };

  const cgstAmount = {
    name: "CGST Amt",
    selector: (row) => row.cgstAmount,
    sortable: true,
    width: "110px",
    cell: (row) => (
      <div>
        <p className="m-0 p-0 pt-1 fw-bold">
          {hasValue(row.cgstAmount) ? `${row.cgstAmount}` : ""}
        </p>
      </div>
    ),
  };
  const cgstPercent = {
    name: "CGST %",
    selector: (row) => row.cgstPercent,
    sortable: true,
    width: "110px",
    cell: (row) => (
      <div>
        <p className="m-0 p-0 pt-1 fw-bold">
          {hasValue(row.cgstPercent) ? `${row.cgstPercent}%` : ""}
        </p>
      </div>
    ),
  };
  const sgstAmount = {
    name: "SGST Amt",
    selector: (row) => row.sgstAmount,
    sortable: true,
    width: "110px",
    cell: (row) => (
      <div>
        <p className="m-0 p-0 pt-1 fw-bold">
          {hasValue(row.sgstAmount) ? `${row.sgstAmount}%` : ""}
        </p>
      </div>
    ),
  };
  const sgstPercent = {
    name: "SGST %",
    selector: (row) => row.sgstPercent,
    sortable: true,
    width: "110px",
    cell: (row) => (
      <div>
        <p className="m-0 p-0 pt-1 fw-bold">
          {hasValue(row.sgstPercent) ? `${row.sgstPercent}%` : ""}
        </p>
      </div>
    ),
  };
  const igstAmount = {
    name: "IGST Amt",
    selector: (row) => row.igstAmount,
    sortable: true,
    width: "110px",
    cell: (row) => (
      <div>
        <p className="m-0 p-0 pt-1 fw-bold">
          {hasValue(row.igstAmount) ? `${row.igstAmount}` : ""}
        </p>
      </div>
    ),
  };
  const igstPercent = {
    name: "IGST %",
    selector: (row) => row.igstPercent,
    sortable: true,
    width: "110px",
    cell: (row) => (
      <div>
        <p className="m-0 p-0 pt-1 fw-bold">
          {hasValue(row.igstPercent) ? `${row.igstPercent}%` : ""}
        </p>
      </div>
    ),
  };
  const discount = {
    name: "Discount",
    selector: (row) => row.discount,
    sortable: true,
    width: "100px",
    cell: (row) => (
      <div>
        <p className="m-0 p-0 pt-1 fw-bold">{row.discount} </p>
      </div>
    ),
  };
  const taxableValue = {
    name: "Taxable Value",
    selector: (row) => row.taxableValue,
    sortable: true,
    width: "130px",
    cell: (row) => (
      <div>
        <p className="m-0 p-0 pt-1 fw-bold">{row?.taxableValue} </p>
      </div>
    ),
  };
  const total = {
    name: "Total",
    selector: (row) => row.total,
    sortable: true,
    width: "130px",
    cell: (row) => (
      <div>
        <p className="m-0 p-0 pt-1 fw-bold">{row?.total} </p>
      </div>
    ),
  };

  // const totalColumn = {
  //   name: "Total Amount",
  //   selector: (row) => row.total,
  //   sortable: true,
  //   width: "150px",
  //   cell: (row) => (
  //     <div>
  //       <p className="m-0 p-0 pt-1 fw-bold">{row.total} </p>
  //     </div>
  //   ),
  // };

  const shouldShowColumn = (field) =>
    getInvoiceLineItem?.some(
      (item) =>
        item[field] !== null && item[field] !== undefined && item[field] !== "",
    );
  const columns = [
    {
      name: "Sl.No",
      selector: (row) => row.slNo,
      sortable: true,
      width: "80px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.slNo} </p>
        </div>
      ),
    },
    ...(shouldShowColumn("itemCode") ? [itemCode] : []),
    ...(shouldShowColumn("description") ? [description] : []),
    ...(shouldShowColumn("hsnSac") ? [hsnSac] : []),
    ...(shouldShowColumn("unit") ? [unit] : []),
    ...(shouldShowColumn("quantity") ? [quantity] : []),
    ...(shouldShowColumn("rate") ? [rate] : []),
    ...(shouldShowColumn("cgstAmount") ? [cgstAmount] : []),
    ...(shouldShowColumn("cgstPercent") ? [cgstPercent] : []),
    ...(shouldShowColumn("sgstAmount") ? [sgstAmount] : []),
    ...(shouldShowColumn("sgstPercent") ? [sgstPercent] : []),
    ...(shouldShowColumn("discount") ? [discount] : []),
    ...(shouldShowColumn("igstAmount") ? [igstAmount] : []),
    ...(shouldShowColumn("igstPercent") ? [igstPercent] : []),
    ...(shouldShowColumn("taxableValue") ? [taxableValue] : []),
    ...(shouldShowColumn("total") ? [total] : []),

    {
      name: "Action",
      width: "90px",
      center: true,
      cell: (row) => (
        <button className="btnTable" onClick={() => openItemEdit(row)}>
          <i className="bi bi-pencil-square mr-1"></i>Edit
        </button>
      ),
    },
  ];

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    setParentInfo(props?.invoiceinfo);
    if (props?.viewInvoiceData) {
      setInvoiceData(props?.viewInvoiceData);
      setViewInvoiceDataStatus(true);
    } else {
      setInvoiceData({
        vendorInvoiceNo: "",
        vendorInvoiceDate: "",
        vendorBasicValue: "",
        vendorTotalInvoiceValue: "",
        dispInvoiceStatusHeader: "",
        dispCreatedBy: "",
        dispCreatedByName: "",
        deliveryName: "",
        dispTotalQty: "",
        dispBasicPricePerUnit: "",
        dispBasicPrice: "",
        dispCGST: 0,
        dispSGST: 0,
        dispTransporterCode: "",
        dispTransporterName: "",
        dispVehieleRegNo: "",
        dispCustomerCode: "",
        igst: "",
        supplierGSTIN: "",
        supplierPAN: "",
        supplierPhone: "",
        taxAmountInWords: "",
        items: [],
        dispCompanyBankDetails: [],
        invoiceBillDocument: "",
        purchasingDocumentNr: "",
        purchasingDocumentDate: "",
        purchasingDocumentValue: "",
        currencyCode: "",
        currency: "",
        vendorCode: "",
        vendorName: "",
        paymentTerms: "",
        incoTerms: "",
        companyCodeCode: "",
        purchaseType: "",
        invoiceType: "",
        dispgst: 0,
      });
      setInvoiceLineItem([]);
    }

    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  useEffect(() => {
    const items = invoiceData?.items || [];

    // Only recompute from line items when line items are present.
    // Otherwise keep the OCR-provided values (dispcgst/sgst/totalQty).
    if (!items.length) return;

    // ✅ Calculate total basic amount
    const totalBasicAmount = items.reduce((acc, item) => {
      const amount = parseFloat(item.basicAmount) || 0;
      return acc + amount;
    }, 0);

    // ✅ Calculate GST
    const gst = (totalBasicAmount * 18) / 100;
    const cgst = gst / 2;
    const sgst = gst / 2;

    // ✅ Calculate total order quantity
    const totalQuantity = items.reduce((acc, item) => {
      const qty = parseFloat(item.orderQuantityLoad) || 0;
      return acc + qty;
    }, 0);

    // ✅ Update invoice data (GST)
    setInvoiceData((prev) => ({
      ...prev,
      dispgst: gst.toFixed(2),
      totalOrderQuantity: totalQuantity,
      vendorTaxValue: gst.toFixed(2),
      dispCGST: cgst.toFixed(2),
      dispSGST: sgst.toFixed(2),
    }));

    // ✅ Update total order quantity
    setTotalOrderQuantity(totalQuantity);
  }, [invoiceData?.items]);

  // Keep the Invoice Items table in sync with the current items (upload / view / edit)
  useEffect(() => {
    setInvoiceLineItem(invoiceData?.items || []);
  }, [invoiceData?.items]);

  const handleFileChange = (event) => {
    // const selectedFile = event.target.files[0];
    setFile(event.target.files[0]);
  };

  const selectFile = () => {
    fileInputRef?.current?.click();
  };
  const cancelInvoice = () => {
    // Bump the token so any in-flight uploadInvoice response is discarded
    uploadTokenRef.current += 1;
    setUploadStatus(false);
    setFile(null);
  };

  const uploadInvoice = async () => {
    // Capture the current token; the response is ignored if the user cancels first
    const uploadToken = uploadTokenRef.current;
    setUploadStatus(true);
    if (file) {
      // Create FormData and append the file
      const formData = new FormData();
      formData.append("file", file);
      formData.append("module", "Invoice");
      formData.append("filePath", "invoice");

      await ItemService.uploadInvoiceOCR(formData).then(async (item) => {
        // If cancelInvoice was clicked while this request was in flight, stop here
        if (uploadToken !== uploadTokenRef.current) return;
        // Graceful handling: an OCR failure (e.g. HTTP 429 AI rate limit) resolves
        // as { status, message } with no data — show the server message and stop
        // instead of silently populating an empty invoice.
        if (!item?.data) {
          toast.error(
            item?.message || "Invoice OCR upload failed. Please try again.",
            { position: "top-right" },
          );
          setUploadStatus(false);
          return;
        }
        const ocrData = item?.data || {};
        const ocrItems =
          ocrData?.lineItems?.map((line, index) => ({
            ...line,
            slNo: index + 1,
          })) || [];

        // The uploaded OCR file also becomes the Invoice Bill Document.
        // Prefer the attachmentId returned by OCR; otherwise upload the same
        // file through the attachment uploader (uploadFiles) to get one.
        let attachmentId = ocrData?.attachmentId;
        if (!attachmentId && file) {
          try {
            const attachForm = new FormData();
            attachForm.append("files", file);
            const up = await ItemService.uploadFiles(attachForm);
            attachmentId = up?.attachmentId;
          } catch (err) {
            console.error("Invoice bill attachment upload failed:", err);
          }
        }

        setOcrInvoiceData({
          vendorInvoiceNo: ocrData?.invoiceNumber,
          vendorInvoiceDate: ocrData?.invoiceDate,
          vendorBasicValue: ocrData?.subtotal,
          vendorTotalInvoiceValue: ocrData?.grandTotal,
          dispInvoiceStatusHeader: ocrData?.invoiceStatusHeader,
          dispCreatedBy: ocrData?.createdBy,
          dispCreatedByName: ocrData?.createdByName,
          deliveryName: ocrData?.description,
          dispTotalQty:
            ocrData?.totalQty ||
            ocrItems?.reduce(
              (acc, line) => acc + (parseFloat(line?.quantity) || 0),
              0,
            ),
          dispBasicPricePerUnit: ocrData?.basicPricePerUnit,
          dispBasicPrice: ocrData?.subtotal,

          dispCGST: ocrData?.cgst,
          dispSGST: ocrData?.sgst,

          dispTransporterCode: ocrData?.transporterCode,
          dispTransporterName: ocrData?.transporterName,
          dispVehieleRegNo: ocrData?.vehicleNumber,
          dispCustomerCode: ocrData?.customerCode,
          igst: ocrData?.igst,
          supplierGSTIN: ocrData?.supplierGSTIN,
          supplierPAN: ocrData?.supplierPAN,
          supplierName: ocrData?.supplierName,
          supplierPhone: ocrData?.supplierPhone,
          taxAmountInWords: ocrData?.taxAmountInWords,
          vendorName: ocrData?.supplierName,
          items: ocrItems,
          dispCompanyBankDetails: ocrData?.companyBankDetails,
          invoiceBillDocument: attachmentId || "",
          attachmentId: attachmentId || "",

          purchasingDocumentNr:
            ocrData?.purchaseOrderNumber || getHeaderData?.purchasingDocumentNr,
          purchasingDocumentDate: getHeaderData?.purchasingDocumentDate,
          purchasingDocumentValue: getHeaderData?.purchasingDocumentValue,

          currencyCode: getHeaderData?.currencyCode,
          currency: getHeaderData?.currency,

          vendorCode: getHeaderData?.vendorCode,
          supplierCode: ocrData?.supplierCode || ocrData?.vendorCode,
          paymentTerms: getHeaderData?.paymentTerms,
          incoTerms: getHeaderData?.incoTerms,
          companyCodeCode: getHeaderData?.companyCodeCode,
          purchaseType: getHeaderData?.purchaseType,

          invoiceType: "OCR",
        });
        setInvoiceLineItem(ocrItems);
        setInvoiceData({
          vendorInvoiceNo: ocrData?.invoiceNumber,
          vendorInvoiceDate: ocrData?.invoiceDate,
          vendorBasicValue: ocrData?.subtotal,
          vendorTotalInvoiceValue: ocrData?.grandTotal,
          dispInvoiceStatusHeader: ocrData?.invoiceStatusHeader,
          dispCreatedBy: ocrData?.createdBy,
          dispCreatedByName: ocrData?.createdByName,
          deliveryName: ocrData?.description,
          dispTotalQty:
            ocrData?.totalQty ||
            ocrItems?.reduce(
              (acc, line) => acc + (parseFloat(line?.quantity) || 0),
              0,
            ),
          dispBasicPricePerUnit: ocrData?.basicPricePerUnit,
          dispBasicPrice: ocrData?.subtotal,

          dispCGST: ocrData?.cgst,
          dispSGST: ocrData?.sgst,

          dispTransporterCode: ocrData?.transporterCode,
          dispTransporterName: ocrData?.transporterName,
          dispVehieleRegNo: ocrData?.vehicleNumber,
          dispCustomerCode: ocrData?.customerCode,
          igst: ocrData?.igst,
          supplierGSTIN: ocrData?.supplierGSTIN,
          supplierPAN: ocrData?.supplierPAN,
          supplierName: ocrData?.supplierName,
          supplierPhone: ocrData?.supplierPhone,
          taxAmountInWords: ocrData?.taxAmountInWords,
          vendorName: ocrData?.supplierName,
          items: ocrItems,
          dispCompanyBankDetails: ocrData?.companyBankDetails,
          invoiceBillDocument: attachmentId || "",
          attachmentId: attachmentId || "",

          purchasingDocumentNr:
            ocrData?.purchaseOrderNumber || getHeaderData?.purchasingDocumentNr,
          purchasingDocumentDate: getHeaderData?.purchasingDocumentDate,
          purchasingDocumentValue: getHeaderData?.purchasingDocumentValue,

          currencyCode: getHeaderData?.currencyCode,
          currency: getHeaderData?.currency,

          vendorCode: getHeaderData?.vendorCode,
          supplierCode: ocrData?.supplierCode || ocrData?.vendorCode,
          paymentTerms: getHeaderData?.paymentTerms,
          incoTerms: getHeaderData?.incoTerms,
          companyCodeCode: getHeaderData?.companyCodeCode,
          purchaseType: getHeaderData?.purchaseType,

          invoiceType: "OCR",
        });
        setFile(null);
      });
      setUploadStatus(false);
    } else {
      // alert('Please select a file first.');
    }
  };

  //handle cancel modal
  const handleCancel = () => {
    // Cancel any in-flight upload so its response is discarded (same as cancelInvoice)
    uploadTokenRef.current += 1;
    setUploadStatus(false);
    setOcrInvoiceData({});
    setInvoiceData({});
    setParentInfo();
    setInvoiceData();
    setViewInvoiceDataStatus();
    setInvoiceLineItem();
    props.onHide();
  };

  useEffect(() => {
    if (!getShowSuccessModal && wasModalShown) {
      props.onHide(); // Call only when modal transitions from true → false
      setWasModalShown(false); // Reset tracker
    }
  }, [getShowSuccessModal, wasModalShown, props]);
  /* Show Success Modal */
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  // Compare the OCR invoice against the PO (props.viewInvoiceData) before
  // saving. PO number, Supplier Code and Total Amount must match the PO; if any
  // is missing or mismatched the invoice cannot be created. props.viewInvoiceData
  // is the authoritative PO the parent passes in, so this never depends on
  // state that may be stale/empty on reopen.
  const validateInvoiceAgainstPO = async () => {
    // PO source: props.viewInvoiceData (authoritative), else the loaded header.
    let po = props?.viewInvoiceData;
    if (!po) {
      const loaded = await loadInitialPageData();
      po = loaded || getHeaderData;
    }
    if (!po) return ["PO data is not loaded. Cannot create invoice."];
    // Invoice source: the OCR-extracted invoice (kept in ocrInvoiceData, and
    // mirrored into invoiceData.items) — compare its values against the PO.
    const inv =
      ocrInvoiceData && Object.keys(ocrInvoiceData).length
        ? ocrInvoiceData
        : invoiceData;
    const errors = [];

    // 1. Supplier Code — compulsory and must match the PO vendor
    const invSupplier = String(
      inv?.supplierCode || inv?.vendorCode || "",
    ).trim();
    const poSupplier = String(po?.vendorCode || "").trim();
    if (!invSupplier) {
      errors.push("Supplier Code is required on the invoice.");
    } else if (!poSupplier) {
      errors.push("Supplier Code is missing on the PO.");
    } else if (invSupplier !== poSupplier) {
      errors.push(
        `Supplier Code mismatch: invoice "${invSupplier}" vs PO "${poSupplier}"`,
      );
    }

    // 2. PO Code — compulsory and must match the PO number. The OCR-extracted
    // invoice number may carry a version/revision tag (e.g. "PO0139 (V0)")
    // that the PO number itself does not. Strip such a trailing "(V#)" tag
    // before comparing so the two are treated as the same PO; the original
    // values are kept for the error message.
    const stripPoVersion = (nr) =>
      String(nr || "").trim().replace(/\s*\(V\d+\)\s*$/i, "");
    const invPoNr = String(
      inv?.purchaseOrderNumber || inv?.purchasingDocumentNr || "",
    ).trim();
    const poNr = String(
      po?.purchasingDocumentNr ||
        props?.invoiceinfo?.purchasingDocumentNr ||
        "",
    ).trim();
    if (!invPoNr) {
      errors.push("PO Code is required on the invoice.");
    } else if (!poNr) {
      errors.push("PO Code is missing on the PO.");
    } else if (stripPoVersion(invPoNr) !== stripPoVersion(poNr)) {
      errors.push(`PO Code mismatch: invoice "${invPoNr}" vs PO "${poNr}"`);
    }

    // 3. Total Amount — the OCR invoice total must match the PO total
    const invTotal =
      Number(
        inv?.vendorTotalInvoiceValue ??
          inv?.grandTotal ??
          inv?.purchasingDocumentValue,
      ) || 0;
    const poTotal = Number(po?.purchasingDocumentValue || po?.grandTotal) || 0;
    if (!invTotal) {
      errors.push("Total amount is required on the invoice.");
    } else if (!poTotal) {
      errors.push("Total amount is missing on the PO.");
    } else if (Math.abs(invTotal - poTotal) > 0.01) {
      errors.push(
        `Total amount mismatch: invoice "${invTotal}" vs PO "${poTotal}"`,
      );
    }

    return errors;
  };

  // Build the create-invoice payload with the keys InvoiceDetails expects.
  // Header values come from the PO (authoritative); invoice-no/date/totals from the OCR upload.
  const buildInvoicePayload = () => {
    const po = getHeaderData || {};
    const inv = invoiceData || {};
    const items =
      po.items && po.items.length
        ? po.items
        : inv.items && inv.items.length
          ? inv.items
          : [];

    return {
      transactionActivity: "INV",
      subTransactionActivity: "GRN",

      // PO / vendor header
      vendorCode: po.vendorCode || inv.vendorCode,
      vendorName: po.vendorName || inv.vendorName,
      purchasingDocumentNr:
        po.purchasingDocumentNr ||
        inv.purchasingDocumentNr ||
        parentInfo?.purchasingDocumentNr,
      purchasingDocumentDate:
        po.purchasingDocumentDate || inv.purchasingDocumentDate,
      purchasingDocumentValue:
        po.purchasingDocumentValue || inv.purchasingDocumentValue,
      currency: po.currency || inv.currency,
      currencyCode: po.currencyCode || inv.currencyCode || "INR",
      paymentTerms: po.paymentTerms || inv.paymentTerms,

      // invoice-only fields
      vendorInvoiceNo: inv.vendorInvoiceNo || "",
      vendorInvoiceDate: inv.vendorInvoiceDate || "",
      vendorInvoiceCurrency: po.currencyCode || inv.currencyCode || "INR",
      invoiceValue: inv.invoiceValue ?? inv.vendorTotalInvoiceValue ?? 0,
      invoiceBillDocument: inv.invoiceBillDocument || inv.attachmentId || "",
      vendorBasicValue:
        po.purchasingDocumentItemTotalValue ?? inv.vendorBasicValue ?? 0,
      vendorFreightValue: inv.vendorFreightValue ?? 0,
      vendorTaxValue:
        po.purchasingDocumentTaxTotalValue ?? inv.vendorTaxValue ?? 0,
      vendorOtherChargesValue: inv.vendorOtherChargesValue ?? 0,
      vendorTotalInvoiceValue:
        po.purchasingDocumentValue ?? inv.vendorTotalInvoiceValue ?? 0,
      totalOrderQuantity: inv.totalOrderQuantity ?? inv.dispTotalQty ?? 0,

      invoiceType: inv.invoiceType || "NotOCR",
      invoiceStatusHeader: "Invoice Created",
      generatedBy: po.initiator || inv.initiator,
      createdBy: po.initiator || inv.initiator,

      items: items.map((it) => ({
        invoiceItemNr:
          it.invoiceItemNr ??
          it.purchasingDocumentItemNr ??
          it.local_id ??
          it.slNo,
        purchasingDocumentItemNr: it.purchasingDocumentItemNr || it.lineNo,
        purchasingDocumentNr:
          po.purchasingDocumentNr || inv.purchasingDocumentNr,
        grnNr: it.grnNr ?? "",
        grnItemNr: it.grnItemNr ?? "",
        materialCode: it.materialCode || it.itemCode || "",
        materialDescription:
          it.materialDescription || it.description || it.materialLongText || "",
        materialLongText:
          it.materialLongText || it.materialDescription || it.description || "",
        invoiceQuantity:
          it.invoiceQuantity ?? it.purchaseQuantity ?? it.quantity ?? 0,
        orderUnitOfMeasure: it.orderUnitOfMeasure || it.unit || "",
        originalUnitPrice:
          it.originalUnitPrice ?? it.orderPriceUnit ?? it.rate ?? 0,
        orderPriceUnit: it.orderPriceUnit ?? it.rate ?? 0,
        totalPrice: it.totalPrice ?? it.total ?? it.netValue ?? 0,
        taxCode: it.taxCode ?? 0,
        taxAmount: it.taxAmount ?? it.taxableValue ?? 0,
        netValue: it.netValue ?? it.total ?? it.totalPrice ?? 0,
        invBalancePurchaseQuantity:
          it.invBalancePurchaseQuantity ??
          it.purchaseQuantity ??
          it.quantity ??
          0,
        currencyCode:
          it.currencyCode || it.itemCurrency || po.currencyCode || "INR",
        deliveryDate: it.deliveryDate ?? "",
        remarks: it.remarks ?? "",
        taxIdDesc: it.taxIdDesc ?? "",
        purchaseReqNr: it.purchaseReqNr ?? "",
        purchaseReqitemNr: it.purchaseReqitemNr ?? "",
      })),
    };
  };

  const handleSave = async () => {
    const vErrors = await validateInvoiceAgainstPO();
    if (vErrors.length) {
      toast.error(vErrors.join(" | "), {
        duration: 6000,
        position: "top-right",
      });
      return;
    }

    const obj = {
      data: {
        ...buildInvoicePayload(),
        ...parentInfo,
      },
    };
    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });
    try {
      setDisabled(true);

      const item = await ItemService.addInvoice(obj);

      if (item?.status === 200) {
        const invNo =
          invoiceData?.vendorInvoiceNo || ocrInvoiceData?.vendorInvoiceNo || "";
        modalData.successMsg = invNo
          ? `${item?.message} Invoice No: ${invNo}`
          : item?.message;
        setModalInfo(modalData);
        onSuccessfullyRegistered();
        setWasModalShown(true);

        dispatch(getInvoiceList());
        // props.onsuccessdata(obj);
        //   props.onHide();
      } else {
        toast.error(item?.message || "Please try again!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Error while saving invoice:", error);
      toast.error("Something went wrong!", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      toast.dismiss(toastId);
      setDisabled(false);
    }
  };

  // Handle edits to the "Uploaded Invoice details" block
  const handleInvoiceFieldChange = (e) => {
    const { name, value } = e.target;
    if (!name) return;
    setInvoiceData((prev) => ({ ...prev, [name]: value }));
  };

  // Open line-item edit popup. Ensure all expected keys exist on the item
  // (null defaults) so they are never dropped from the payload; the popup
  // only renders an input for keys that actually carry a value.
  const ITEM_EDIT_DEFAULTS = {
    lineNo: null,
    itemCode: null,
    description: null,
    hsnSac: null,
    quantity: null,
    unit: null,
    rate: null,
    discount: null,
    taxableValue: null,
    cgstPercent: null,
    cgstAmount: null,
    sgstPercent: null,
    sgstAmount: null,
    igstPercent: null,
    igstAmount: null,
    cess: null,
    total: null,
  };
  const openItemEdit = (row) => {
    setEditingItem({ ...ITEM_EDIT_DEFAULTS, ...row });
    setShowItemModal(true);
  };
  const closeItemEdit = () => {
    setShowItemModal(false);
    setEditingItem(null);
  };
  const handleItemFieldChange = (e) => {
    const { name, value } = e.target;
    if (!name) return;
    setEditingItem((prev) => ({ ...prev, [name]: value }));
  };

  // Apply a line-item edit to internal state + persist via updatePOFields
  const commitItemEdit = async () => {
    if (!editingItem) return;
    const updated = getInvoiceLineItem.map((row) =>
      row.slNo === editingItem.slNo ? { ...editingItem } : row,
    );
    setInvoiceLineItem(updated);
    setInvoiceData((prev) => ({ ...prev, items: updated }));
    closeItemEdit();

    const toastId = toast.loading("Updating...", { position: "top-right" });
    try {
      const res = await ItemService.updatePOFields({
        ...invoiceData,
        items: updated,
      });
      if (res?.status === 200) {
        toast.success(res?.message || "Updated successfully", {
          duration: 4000,
          position: "top-right",
        });
        props?.onsuccessdata?.({ ...invoiceData, items: updated });
      } else {
        toast.error(res?.message || "Please try again!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Error while updating item:", error);
      toast.error("Something went wrong!", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      toast.dismiss(toastId);
    }
  };

  // Update the uploaded invoice details via addInvoiceFromOCR
  const handleUpdate = async () => {
    const vErrors = await validateInvoiceAgainstPO();
    if (vErrors.length) {
      toast.error(vErrors.join(" | "), {
        duration: 6000,
        position: "top-right",
      });
      return;
    }

    const toastId = toast.loading("Loading...", { position: "top-right" });
    try {
      setDisabled(true);
      const payload = {
        data: {
          vendorCode: invoiceData?.vendorCode,
          vendorName: invoiceData?.vendorName,
          purchaseTypeCode: invoiceData?.purchaseType,
          purchasingDocumentNr:
            invoiceData?.purchasingDocumentNr ||
            props?.invoiceinfo?.purchasingDocumentNr,
          vendorInvoiceNo: invoiceData?.vendorInvoiceNo,
          vendorInvoiceDate: invoiceData?.vendorInvoiceDate,
          purchasingDocumentDate: invoiceData?.purchasingDocumentDate,
          vendorTotalInvoiceValue: invoiceData?.vendorTotalInvoiceValue,
          currency: invoiceData?.currency,
          currencyCode: invoiceData?.currencyCode,
          paymentTerms: invoiceData?.paymentTerms,
          companyCode: invoiceData?.companyCodeCode || invoiceData?.companyCode,
          items: (invoiceData?.items || []).map((line) => ({
            purchasingDocumentNr: invoiceData?.purchasingDocumentNr,
            purchasingDocumentItemNr: line?.purchasingDocumentItemNr,
            grnNr: line?.grnNr,
            grnItemNr: line?.grnItemNr,
            materialCode: line?.materialCode || line?.itemCode,
            materialDescription: line?.materialDescription || line?.description,
            invoiceQuantity: line?.invoiceQuantity ?? line?.quantity,
            unitPrice: line?.unitPrice ?? line?.rate,
            orderPriceUnit: line?.orderPriceUnit,
            uOM: line?.uOM || line?.unit,
            netValue: line?.netValue ?? line?.total,
            taxCode: line?.taxCode,
            taxAmount: line?.taxAmount,
          })),
          imageResponse: invoiceData?.imageResponse || {},
          attachmentId:
            invoiceData?.attachmentId || invoiceData?.invoiceBillDocument,
        },
      };
      const item = await ItemService.addInvoiceFromOCR(payload);
      if (item?.status === 200) {
        const invNo =
          invoiceData?.vendorInvoiceNo ||
          ocrInvoiceData?.vendorInvoiceNo ||
          payload?.data?.vendorInvoiceNo ||
          "";
        modalData.successMsg = invNo ? `${item?.message}` : item?.message;
        setModalInfo(modalData);
        onSuccessfullyRegistered();
        setWasModalShown(true);
        props?.onsuccessdata?.(payload.data);
        dispatch(getInvoiceList());
      } else {
        toast.error(item?.message || "Please try again!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Error while updating invoice:", error);
      toast.error("Something went wrong!", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      toast.dismiss(toastId);
      setDisabled(false);
    }
  };

  // Always resolves with the PO header for the current PO (or null).
  // The modal stays mounted across opens, so we clear stale header data from a
  // previously-opened PO BEFORE fetching, otherwise validation would compare the
  // new invoice against the wrong PO.
  const loadInitialPageData = async () => {
    // setLoading(true);

    if (props?.invoiceinfo?.purchasingDocumentNr) {
      let obj = {
        documentNumber: props?.invoiceinfo?.purchasingDocumentNr,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      setHeaderData(null);
      let loaded = null;
      await ItemService.getPurchaseOrderDetail(obj).then((item) => {
        // console.log(">> Details res!", item);
        if (item?.status === 200) {
          // setHeaderData(item?.data);
          setHeaderData(item?.data);
          loaded = item?.data;
          // dispatch(addPoSelectedDetails(item?.data));
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });
      return loaded;

      // setLoading(false);
    }
  };
  useEffect(() => {
    loadInitialPageData();
    // eslint-disable-next-line
  }, [props]);

  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton onHide={handleCancel}>
        <Modal.Title id="contained-modal-title-vcenter">
          Invoice Confirmation - {parentInfo?.purchasingDocumentNr}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col
            xs={6}
            md={3}
            lg={3}
            className="d-flex justify-content-end mr-2 mb-2"
          >
            {!file && (
              <button onClick={selectFile} className="btnTable">
                <i className="bi bi-upload mr-2"></i>
                Upload Invoice
              </button>
            )}

            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
            />

            {file && (
              <>
                {!uploadStatus && (
                  <button className="btnTable" onClick={uploadInvoice}>
                    <i className="bi bi-upload mr-2"></i>
                    Upload
                  </button>
                )}

                {uploadStatus && (
                  <button className="btnTable" disabled={true}>
                    <Spinner
                      as="span"
                      animation="grow"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    Loading...
                  </button>
                )}
              </>
            )}
          </Col>

          {file && (
            <Col xs={6} md={3} lg={3} className="mb-2 ml-2">
              <button className="btnDelete" onClick={cancelInvoice}>
                <i className="bi bi-x-circle"></i>
              </button>
            </Col>
          )}
        </Row>
        <Row className="commTopButtonRightLeftPadding">
          <Col xs={6} md={6} lg={6}>
            {file && (
              <p className="">
                File: <b>{file.name}</b>{" "}
              </p>
            )}
          </Col>
        </Row>

        {/* Upload invoice details */}
        {ocrInvoiceData && Object.keys(ocrInvoiceData).length > 0 ? (
          <>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">UI</span>
                    </Col>

                    <Col xs={4} md={4} lg={4}>
                      <span className="headerTitle">
                        {" "}
                        Uploaded Invoice details
                      </span>
                      <span className="subHeaderTitle">Invoice details</span>
                    </Col>
                    {!viewInvoiceDataStatus && (
                      <Col xs={12} md={6} lg={6} className="headerButtonAlign">
                        {/* <Col
                      xs={6}
                      md={6}
                      lg={6}
                      className="d-flex justify-content-end mr-2 mt-1"
                    >
                      {file && (
                        <p>
                          File: <b>{file.name}</b>{" "}
                        </p>
                      )}
                    </Col> */}
                        {/*  <Col xs={6} md={3} lg={3} className="">
                      {!file && (
                        <button onClick={selectFile} className="btnTable">
                          <i className="bi bi-upload mr-2"></i>
                          Select Invoice
                        </button>
                      )}
                      <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />

                      {file && (
                        <>
                          {!uploadStatus && (
                            <button
                              className="btnTable"
                              onClick={uploadInvoice}
                            >
                              <i className="bi bi-upload mr-2"></i>
                              Upload
                            </button>
                          )}

                          {uploadStatus && (
                            <button className="btnTable" disabled={true}>
                              <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                              Loading...
                            </button>
                          )}
                        </>
                      )}
                    </Col>
                    {file && (
                      <Col xs={6} md={1} lg={1} className="">
                        <button className="btnDelete" onClick={cancelInvoice}>
                          <i className="bi bi-x-circle"></i>
                        </button>
                      </Col>
                    )} */}
                      </Col>
                    )}
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            {/* <Col
                              xs={12}
                              md={4}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Purchase Order Code"
                                name="purchasingDocumentNr"
                                id="purchasingDocumentNr"
                                value={invoiceData?.purchasingDocumentNr || ""}
                                onChange={handleInvoiceFieldChange}
                              />
                            </Col> */}
                            {hasValue(invoiceData?.supplierCode) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Supplier Code"
                                  name="supplierCode"
                                  id="supplierCode"
                                  value={invoiceData?.supplierCode || ""}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.vendorInvoiceNo) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Invoice Number"
                                  name="vendorInvoiceNo"
                                  id="vendorInvoiceNo"
                                  value={invoiceData?.vendorInvoiceNo}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.vendorInvoiceDate) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Invoice Date"
                                  name="vendorInvoiceDate"
                                  id="vendorInvoiceDate"
                                  value={invoiceData?.vendorInvoiceDate}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {/* <Col
                          xs={12}
                          md={4}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Invoice Status"
                            name="dispInvoiceStatusHeader"
                            id="dispInvoiceStatusHeader"
                            value={invoiceData?.dispInvoiceStatusHeader}
                            disabled={true}
                          />
                        </Col> */}
                            {/* <Col
                          xs={12}
                          md={4}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Created By"
                            name="dispCreatedBy"
                            id="dispCreatedBy"
                            value={invoiceData?.dispCreatedBy}
                            disabled={true}
                          />
                        </Col> */}
                            {/* <Col
                          xs={12}
                          md={4}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Created By Name"
                            name="dispCreatedByName"
                            id="dispCreatedByName"
                            value={invoiceData?.dispCreatedByName}
                            disabled={true}
                          />
                        </Col> */}
                            {hasValue(invoiceData?.vendorName) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Delivery"
                                  name="vendorName"
                                  id="vendorName"
                                  value={invoiceData?.vendorName}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(
                              invoiceData?.dispTotalQty || totalOrderQuantity,
                            ) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Total Qty"
                                  name="dispTotalQty"
                                  id="dispTotalQty"
                                  value={
                                    invoiceData?.dispTotalQty ||
                                    totalOrderQuantity
                                  }
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}

                            {hasValue(invoiceData?.vendorBasicValue) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Basic Price"
                                  name="dispBasicPrice"
                                  id="dispBasicPrice"
                                  // value={invoiceData?.dispBasicPrice}
                                  value={invoiceData?.vendorBasicValue}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}

                            {hasValue(invoiceData?.dispCGST) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="CGST"
                                  name="dispCGST"
                                  id="dispCGST"
                                  value={invoiceData?.dispCGST}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}

                            {hasValue(invoiceData?.dispSGST) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="SGST"
                                  name="dispSGST"
                                  id="dispSGST"
                                  value={invoiceData?.dispSGST}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.dispBasicPricePerUnit) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Basic Price Per Unit"
                                  name="dispBasicPricePerUnit"
                                  id="dispBasicPricePerUnit"
                                  value={invoiceData?.dispBasicPricePerUnit}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.dispTransporterCode) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Transporter Code"
                                  name="dispTransporterCode"
                                  id="dispTransporterCode"
                                  value={invoiceData?.dispTransporterCode}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.dispTransporterName) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Transporter Name"
                                  name="dispTransporterName"
                                  id="dispTransporterName"
                                  value={invoiceData?.dispTransporterName}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.dispVehieleRegNo) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Vehicle Reg No"
                                  name="dispVehieleRegNo"
                                  id="dispVehieleRegNo"
                                  value={invoiceData?.dispVehieleRegNo}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.dispCustomerCode) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Customer Code"
                                  name="dispCustomerCode"
                                  id="dispCustomerCode"
                                  value={invoiceData?.dispCustomerCode}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.igst) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="IGST"
                                  name="igst"
                                  id="igst"
                                  value={invoiceData?.igst}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.supplierGSTIN) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Supplier GSTIN"
                                  name="supplierGSTIN"
                                  id="supplierGSTIN"
                                  value={invoiceData?.supplierGSTIN}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.supplierPAN) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Supplier PAN"
                                  name="supplierPAN"
                                  id="supplierPAN"
                                  value={invoiceData?.supplierPAN}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.supplierName) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Supplier Name"
                                  name="supplierName"
                                  id="supplierName"
                                  value={invoiceData?.supplierName}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.supplierPhone) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Supplier Phone"
                                  name="supplierPhone"
                                  id="supplierPhone"
                                  value={invoiceData?.supplierPhone}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.taxAmountInWords) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Tax Amount in Words"
                                  name="taxAmountInWords"
                                  id="taxAmountInWords"
                                  value={invoiceData?.taxAmountInWords}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}

                            {/* <Col
                          xs={12}
                          md={4}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Total Net Value"
                            name="vendorBasicValue"
                            placeholder="0.00"
                            id="vendorBasicValue"
                            value={formatNumber(
                              invoiceData?.vendorBasicValue,
                              "comma"
                            )}
                            disabled={true}
                          />
                        </Col> */}
                            {hasValue(invoiceData?.vendorTotalInvoiceValue) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Total Amount"
                                  name="vendorTotalInvoiceValue"
                                  placeholder="0.00"
                                  id="vendorTotalInvoiceValue"
                                  value={invoiceData?.vendorTotalInvoiceValue}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.invoiceBillDocument) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <p className="m-0 p-0 fw-medium">
                                  View Attachments
                                </p>
                                {invoiceData?.invoiceBillDocument ? (
                                  <img
                                    src="assets/img/newIcons/attached-file.png"
                                    className="mt-1 attachmentIcon"
                                    alt="attachments"
                                    onClick={() =>
                                      handleViewFile(
                                        invoiceData?.invoiceBillDocument,
                                      )
                                    }
                                  />
                                ) : (
                                  "--"
                                )}
                              </Col>
                            )}
                            {/* <Col
                              xs={12}
                              md={4}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <FileUploadComponentForHB
                                label="Invoice Bill Document"
                                name="invoiceBillDocument"
                                id="invoiceBillDocument"
                                multiple={false}
                                allowedTypes={[
                                  "application/pdf",
                                  "image/jpeg",
                                  "image/png",
                                  ".pdf",
                                  ".jpg",
                                  ".jpeg",
                                  ".png",
                                ]}
                                value={invoiceData?.invoiceBillDocument}
                                onSuccessUpload={(payload) =>
                                  setInvoiceData((prev) => ({
                                    ...prev,
                                    invoiceBillDocument:
                                      payload?.attachmentId ||
                                      payload?.id ||
                                      prev.invoiceBillDocument,
                                  }))
                                }
                              /> 
                            </Col>*/}
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Invoice Items */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">ID</span>
                    </Col>

                    <Col xs={4} md={4} lg={4}>
                      <span className="headerTitle">Invoice Items</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={getInvoiceLineItem.filter(hasLineItemValues)}
                          // progressPending={loading}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                          paginationRowsPerPageOptions={
                            SupplierConstants.ROW_PER_PAGE
                          }
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : uploadStatus ? (
          <div className="text-center py-4">
            <Spinner
              as="span"
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
              className="me-2"
            />
            Extracting invoice details...
          </div>
        ) : null}

        {/* Header Details */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility2}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">HD</span>
                </Col>
                <Col xs={12} md={2} lg={2}>
                  <span className="headerTitle">Header Details</span>
                  <span className="subHeaderTitle"> </span>
                </Col>
              </Row>
            </h2>

            <div
              className={`accordion-collapse collapse show ${
                isCardVisible2 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row className="pt-2 pb-4">
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Document Number"
                      name="purchasingDocumentNr"
                      placeholder=""
                      value={getHeaderData?.purchasingDocumentNr || ""}
                      disabled={true}
                    />
                  </Col>
                  {/* <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Status"
                                  name="statusHeader"
                                  placeholder=""
                                  value={getHeaderData?.statusHeader || ""}
                                  disabled={true}
                                />
                              </Col> */}
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Document Date"
                      name="purchasingDocumentDate"
                      placeholder=""
                      value={getHeaderData?.purchasingDocumentDate || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Net Value"
                      name="purchasingDocumentValue"
                      placeholder=""
                      value={currencyFormat(
                        Number(getHeaderData?.purchasingDocumentValue).toFixed(
                          2,
                        ),
                      )}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Currency"
                      name="currency"
                      placeholder=""
                      value={`${getHeaderData?.currencyCode} - ${getHeaderData?.currency}`}
                      disabled={true}
                    />
                  </Col>

                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Vendor Code"
                      name="vendorCode"
                      placeholder=""
                      value={getHeaderData?.vendorCode || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Vendor Name"
                      name="vendorName"
                      placeholder=""
                      value={getHeaderData?.vendorName || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Payment Terms"
                      name="paymentTerms"
                      placeholder=""
                      value={getHeaderData?.paymentTerms || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Inco Terms"
                      name="incoTerms"
                      placeholder=""
                      value={getHeaderData?.incoTerms || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Company Code "
                      name="companyCodeCode"
                      id="companyCodeCode"
                      value={getHeaderData?.companyCodeCode}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Purchse Type"
                      name="purchasingRemark"
                      placeholder=""
                      value={getHeaderData?.purchaseType || ""}
                      disabled={true}
                    />
                  </Col>
                  {/* <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding mt-4 pt-3"
                  >
                    <div>
                      <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">
                        Header Text
                      </label>
                      <span
                        style={{ marginLeft: "15px" }}
                        // onClick={() =>
                        //   headerTextShowModal(getHeaderData?.headerTextData)
                        // }
                      >
                        <i className="bi bi-calendar2-week iconTable"></i>
                      </span>
                      <span className="suppliersIcon">
                        {" "}
                        {getHeaderData?.headerTextData?.length || 0}{" "}
                      </span>
                    </div>
                  </Col> */}
                </Row>
              </div>
            </div>
          </div>
        </div>
        <FileViewerModal
          show={getShowFileViewModal}
          onHide={handleViewFileHide}
          fileid={getFileViewData}
        />
        <SuccessRegisterModal
          show={getShowSuccessModal}
          onHide={() => hideSuccessModal()}
          modaldata={getModalInfo}
          aftersuccess={SupplierConstants.POCOLLABRATION_INVOICE}
        />

        {/* Line-item edit popup */}
        <Modal
          show={showItemModal}
          onHide={closeItemEdit}
          size="md"
          centered
          backdrop="static"
        >
          <Modal.Header closeButton={handleCancel}>
            <Modal.Title id="contained-modal-title-vcenter">
              Edit Invoice Item
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              {hasValue(editingItem?.lineNo) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Line No"
                    name="lineNo"
                    id="editLineNo"
                    value={editingItem?.lineNo ?? ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.itemCode) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Item Code"
                    name="itemCode"
                    id="editItemCode"
                    value={editingItem?.itemCode || ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.description) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Description"
                    name="description"
                    id="editDescription"
                    value={editingItem?.description || ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.hsnSac) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="HSN/SAC"
                    name="hsnSac"
                    id="edithsnSac"
                    value={editingItem?.hsnSac || ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.quantity) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Qty"
                    type="number"
                    name="quantity"
                    id="editQuantity"
                    value={editingItem?.quantity ?? ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.unit) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Unit"
                    name="unit"
                    id="editUnit"
                    value={editingItem?.unit || ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.rate) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Rate"
                    type="number"
                    name="rate"
                    id="editRate"
                    value={editingItem?.rate ?? ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.discount) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Discount"
                    type="number"
                    name="discount"
                    id="editDiscount"
                    value={editingItem?.discount ?? ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.taxableValue) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Taxable Value"
                    type="number"
                    name="taxableValue"
                    id="editTaxableValue"
                    value={editingItem?.taxableValue ?? ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.cgstPercent) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="CGST %"
                    type="number"
                    name="cgstPercent"
                    id="editCgstPercent"
                    value={editingItem?.cgstPercent ?? ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.cgstAmount) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="CGST Amount"
                    type="number"
                    name="cgstAmount"
                    id="editCgstAmount"
                    value={editingItem?.cgstAmount ?? ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.sgstPercent) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="SGST %"
                    type="number"
                    name="sgstPercent"
                    id="editSgstPercent"
                    value={editingItem?.sgstPercent ?? ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.sgstAmount) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="SGST Amount"
                    type="number"
                    name="sgstAmount"
                    id="editSgstAmount"
                    value={editingItem?.sgstAmount ?? ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.igstPercent) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="IGST %"
                    type="number"
                    name="igstPercent"
                    id="editIgstPercent"
                    value={editingItem?.igstPercent ?? ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.igstAmount) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="IGST Amount"
                    type="number"
                    name="igstAmount"
                    id="editIgstAmount"
                    value={editingItem?.igstAmount ?? ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.cess) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Cess"
                    type="number"
                    name="cess"
                    id="editCess"
                    value={editingItem?.cess ?? ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.total) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Total Amount"
                    type="number"
                    name="total"
                    id="editTotal"
                    value={editingItem?.total ?? ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
            </Row>
            <Row className="mt-4">
              <Col
                lg={{ span: 2, offset: 8 }}
                className="d-flex justify-content-end"
              >
                <button
                  className="btnTable btn-danger mb-2"
                  onClick={closeItemEdit}
                >
                  Cancel
                </button>
              </Col>
              <Col lg={2} className="d-flex justify-content-end mb-2">
                <button className="btnTable" onClick={commitItemEdit}>
                  Save Item
                </button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>

        {!viewInvoiceDataStatus && (
          <Row className="my-4 ">
            <Col
              lg={{ span: 2, offset: 8 }}
              className="d-flex justify-content-end"
            >
              <button
                className="btnTable btn-danger mb-2"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </Col>
            <Col lg={2} className="d-flex justify-content-end mb-2">
              <button
                className="btnTable"
                onClick={handleSave}
                disabled={disabled}
              >
                Save
              </button>
            </Col>
          </Row>
        )}
        {viewInvoiceDataStatus && (
          <Row className="my-4 ">
            <Col
              lg={{ span: 2, offset: 8 }}
              className="d-flex justify-content-end"
            >
              <button
                className="btnTable btn-danger mb-2"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </Col>
            <Col lg={2} className="d-flex justify-content-end mb-2">
              <button
                className="btnTable"
                onClick={handleUpdate}
                disabled={disabled}
              >
                Update
              </button>
            </Col>
          </Row>
        )}
      </Modal.Body>
    </Modal>
  );
});

export default POInvoiceUploadModal;
